<div class="actions-container">
  <button (click)="actionsMenu.toggleMenuState()" mat-stroked-button color="primary">
    <span class="mr-05">Actions</span>
    <fa-icon class="ml-a" [icon]="['fas', 'chevron-down']"></fa-icon>
  </button>
  <actions-menu #actionsMenu [actionsMenuItems]="widgetActions"></actions-menu>
</div>

